import axios from 'axios';

import { loaderOff, loaderOn, toasterOn } from '../../shared/store/actions';
import url from '../../constants/config';
import * as types from './types';

export const playersFetchDataSuccess = payload => {
  return {
    type: types.FETCH_ALL_PLAYERS,
    payload,
  };
};

export const playerFetchDataSuccess = player => {
  return {
    type: types.FETCH_PLAYER,
    payload: player.data,
  };
};

export const clearPlayer = () => {
  return {
    type: types.CLEAR_PLAYER,
  };
};

export const resetPagination = () => {
  return {
    type: types.RESET_PAGINATION,
  };
};

export const playerDeleteSuccess = playerId => {
  return {
    type: types.DELETE_PLAYER,
    payload: playerId,
  };
};
export const fetchPlayer = (playerId, source = 'direct') => async dispatch => {
  try {
    dispatch(clearPlayer()); // Clear old player data first
    dispatch(loaderOn());
    const token = window.localStorage.getItem('authorization');
    const player = await axios.get(`${url}/players/${playerId}?source=${source}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(loaderOff());
    dispatch(playerFetchDataSuccess(player));
  } catch (err) {
    dispatch(loaderOff());
  }
};

export const fetchPlayers = (filteredUrl = '') => async dispatch => {
  try {
    dispatch(loaderOn());
    const token = window.localStorage.getItem('authorization');
    const response = await axios.get(`${url}/players${filteredUrl}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(loaderOff());
    dispatch(playersFetchDataSuccess(response.data));
  } catch (err) {
    const errMsg = err.response
      ? (typeof err.response.data === 'string' ? err.response.data : err.response.data.message || 'Request failed')
      : err.message;
    dispatch(
      toasterOn({ message: errMsg, type: 'failed' }),
    );
    dispatch(loaderOff());
  }
};

export const fetchFavs = (filteredUrl = '', userEmail) => async dispatch => {
  if (!userEmail) {
    dispatch(loaderOff());
    return;
  }
  try {
    dispatch(loaderOn());
    const token = window.localStorage.getItem('authorization');
    const response = await axios.get(
      `${url}/players/${userEmail}/favourite${filteredUrl}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    dispatch(playersFetchDataSuccess(response.data));
    dispatch(loaderOff());
  } catch (err) {
    const errMsg = err.response
      ? (typeof err.response.data === 'string' ? err.response.data : err.response.data.message || 'Request failed')
      : err.message;
    dispatch(
      toasterOn({ message: errMsg, type: 'failed' }),
    );
    dispatch(loaderOff());
  }
};

export const deletePlayer = (playerId, history) => async dispatch => {
  try {
    dispatch(loaderOn());
    const token = window.localStorage.getItem('authorization');
    await axios.delete(`${url}/players/${playerId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(loaderOff());
    dispatch(playerDeleteSuccess(playerId));
    dispatch(
      toasterOn({ type: 'success', message: 'Player has been deleted!' }),
    );
    history.push(`/available-players`);
  } catch (err) {
    dispatch(toasterOn(err.message));
    dispatch(loaderOff());
  }
};

export const sendMessage = message => async dispatch => {
  try {
    dispatch(loaderOn());
    const token = window.localStorage.getItem('authorization');
    await axios.post(`${url}/email/send`, message, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(loaderOff());
    dispatch(toasterOn({ type: 'success', message: 'Message has been sent!' }));
  } catch (err) {
    dispatch(loaderOff());
    dispatch(
      toasterOn({
        type: 'failed',
        message:
          'Sending message failed! Try again or contact our support line at contact@playsportusa.com',
      }),
    );
  }
};

export const openOrSendFirstMessage = ({ playerId, text }) => async dispatch => {
  try {
    dispatch(loaderOn());
    const token = window.localStorage.getItem('authorization');
    const response = await axios.post(
      `${url}/conversations`,
      { playerId, text },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    dispatch(loaderOff());
    dispatch(toasterOn({ type: 'success', message: 'Message sent!' }));
    return response.data;
  } catch (err) {
    dispatch(loaderOff());
    dispatch(
      toasterOn({
        type: 'failed',
        message: 'Sending message failed! Please try again.',
      }),
    );
    return null;
  }
};

export const sendPlayerInvite = playerId => async dispatch => {
  try {
    dispatch(loaderOn());
    const token = window.localStorage.getItem('authorization');
    await axios.post(
      `${url}/admin/players/${playerId}/send-invite`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    dispatch(loaderOff());
    dispatch(toasterOn({ type: 'success', message: 'Invite sent to player!' }));
  } catch (err) {
    dispatch(loaderOff());
    dispatch(
      toasterOn({
        type: 'failed',
        message: 'Failed to send invite. Please try again.',
      }),
    );
  }
};

export const addFilters = filters => ({
  type: types.ADD_FILTER,
  payload: filters,
});

export const resetFilters = () => ({
  type: types.RESET_FILTERS,
});
